import { c as _c } from "react/compiler-runtime";
import { getChatEmoticon, getChatEmoticonGroup } from '@module/apis/client-side/chat-emoticon';
import type { GetChatEmoticonGroupParams, GetChatEmoticonGroupResponse, GetChatEmoticonParams, GetChatEmoticonResponse } from '@module/apis/client-side/chat-emoticon/type';
import { useQuery } from '@tanstack/react-query';
import type { CustomUseQueryOptions } from '../type';
import { chatEmoticonQueryKeys } from './chatEmoticonQueryKeys';
export const useGetChatEmoticonQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = chatEmoticonQueryKeys.getChatEmoticon(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = () => getChatEmoticon(params);
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useGetChatEmoticonGroupQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = chatEmoticonQueryKeys.getChatEmoticonGroup(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = () => getChatEmoticonGroup(params);
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};